// extracted by mini-css-extract-plugin
module.exports = {"PostOld":"Post-module--PostOld--2RkQ2","Post":"Post-module--Post--3n7c-","Focus":"Post-module--Focus--3jbq1"};